import { ApiResult, HttpClient } from "../http.js";
import { ChangeFeedDto } from "../types/activity.js";

export interface ChangeFeedQuery {
  /** Entity discriminator, e.g. "Leave". */
  entityType?: string;
  /** Restrict to a single entity. */
  entityId?: string;
  /** Restrict to actions by a single user (subject id). */
  actorId?: string;
  /** Restrict to a single project. */
  projectId?: string;
  /** ISO-8601 lower bound (inclusive) on occurredAt. */
  from?: string;
  /** ISO-8601 upper bound (inclusive) on occurredAt. */
  to?: string;
  /** Page size (1..200, default 100). */
  limit?: number;
  /** Opaque pagination cursor from a prior page's nextCursor. */
  cursor?: string;
}

/**
 * The semantic, human-readable activity feed (the .NET replacement for the Firestore
 * `*_CHANGES` change feed). Distinct from the generic field-level audit log.
 */
export class ActivityApi {
  constructor(private readonly http: HttpClient) {}

  feed(query: ChangeFeedQuery = {}): Promise<ApiResult<ChangeFeedDto>> {
    return this.http.get<ChangeFeedDto>("/api/activity/feed", { query: { ...query } });
  }
}
